var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkytouchPms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Skytouch_PMS"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Skytouch_PMS",
    "data-name": "Skytouch PMS",
    clipPath: "url(#clip-Skytouch_PMS)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "security_4318370",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M61.333,41.667A3.331,3.331,0,0,0,58,45V43.333a3.333,3.333,0,1,0-6.667,0V41.667a3.333,3.333,0,0,0-6.667,0V28.333a3.333,3.333,0,1,0-6.667,0V52.3A7.3,7.3,0,0,0,30.7,45a2.7,2.7,0,0,0-2.412,3.9,28.853,28.853,0,0,1,3.047,12.913v4.038a10,10,0,0,0,2.93,7.075L36.333,75v6.667H59.667V75l2.072-2.072a10,10,0,0,0,2.928-7.07V45A3.335,3.335,0,0,0,61.333,41.667Z",
    transform: "translate(18.667 16.667)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M25.667,56H9v3.333H4v3.333H30.667V59.333h-5Z",
    transform: "translate(2.667 37.333)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M11,30h3.333V40H11Z",
    transform: "translate(7.333 20)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M86.667,26.667H85V23.333A23.323,23.323,0,0,0,41.388,11.818l-.828,1.455-1.452-.833A18.288,18.288,0,0,0,11.942,25.29L11.7,26.717l-1.652-.047h-.007a10,10,0,1,0-.045,20H53.333V45a6.667,6.667,0,1,1,13.333,0v1.667h20a10,10,0,1,0,0-20Zm-65,16.667H10a6.673,6.673,0,0,1-6.667-6.667H6.667A3.337,3.337,0,0,0,10,40H21.667Zm6.667,0H25V40h3.333ZM30,16.667A11.678,11.678,0,0,0,18.423,26.873l-3.307-.413A15.014,15.014,0,0,1,30,13.333Zm30,20A11.679,11.679,0,0,1,48.333,25V21.667A11.646,11.646,0,0,1,49,17.778L52.14,18.89a8.322,8.322,0,0,0-.473,2.777V25a8.333,8.333,0,1,0,16.667,0h3.333A11.679,11.679,0,0,1,60,36.667ZM60,20a1.669,1.669,0,0,0-1.667,1.667H55a5,5,0,0,1,10,0V25H61.667V21.667A1.669,1.669,0,0,0,60,20Zm-1.667,5a1.667,1.667,0,0,0,2.5,1.443L62.5,29.33A5,5,0,0,1,55,25Zm10-3.333a8.333,8.333,0,0,0-14.545-5.555L51.3,13.888a11.666,11.666,0,0,1,20.362,7.778Z",
    transform: "translate(0)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M36,38H2.667A1.669,1.669,0,0,0,1,39.667V58H37.667V39.667A1.669,1.669,0,0,0,36,38ZM16,55.357l-4.512-4.512,2.357-2.357L16,50.643l8.822-8.822,2.357,2.357Z",
    transform: "translate(0.667 25.333)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M1,53.667a1.669,1.669,0,0,0,1.667,1.667H36a1.669,1.669,0,0,0,1.667-1.667V52H1Z",
    transform: "translate(0.667 34.667)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkytouchPms);
export default __webpack_public_path__ + "static/media/skytouch-PMS.d9bc19799c7d198e930bb94e157b8aaa.svg";
export { ForwardRef as ReactComponent };